// Size-based delivery pricing (buyer-facing, GBP).
// Parcel tier is a property of the LISTING (set by the seller, defaulted by
// category), never a buyer choice - so a large item can't ship at a small rate.
// These MUST MATCH backend/src/lib/pricing.ts DELIVERY_PRICES (pence there).

export type ParcelTier = 'SMALL' | 'MEDIUM' | 'LARGE';
export type DeliveryService = 'locker' | 'standard' | 'express';

// From Sendcloud GB->GB drop-off estimates (Oct 2026) + ~50p buffer, rounded.
// MUST MATCH backend/src/lib/pricing.ts DELIVERY_PRICES (pence there).
export const DELIVERY_PRICES: Record<DeliveryService, Record<ParcelTier, number>> = {
  locker:   { SMALL: 3.10, MEDIUM: 3.90, LARGE: 5.20 },
  standard: { SMALL: 3.90, MEDIUM: 5.70, LARGE: 5.99 },
  express:  { SMALL: 7.50, MEDIUM: 7.50, LARGE: 8.40 },
};

export const deliveryFee = (s: DeliveryService, tier?: ParcelTier): number =>
  DELIVERY_PRICES[s][tier ?? 'MEDIUM'];

const ORDER: readonly ParcelTier[] = ['SMALL', 'MEDIUM', 'LARGE'];
export const maxTier = (a: ParcelTier, b: ParcelTier): ParcelTier =>
  ORDER.indexOf(a) >= ORDER.indexOf(b) ? a : b;

export const defaultTierForCategory = (category?: string): ParcelTier =>
  ['accessories', 'fragrance', 'watches', 'kids'].includes((category ?? '').toLowerCase()) ? 'SMALL' : 'MEDIUM';

export const TIER_LABEL: Record<ParcelTier, string> = { SMALL: 'Small', MEDIUM: 'Medium', LARGE: 'Large' };

// Seller-facing tier descriptions (weight AND size, since they differ).
export const PARCEL_TIERS: { v: ParcelTier; label: string; hint: string; examples: string }[] = [
  { v: 'SMALL',  label: 'Small',  hint: 'Up to ~1 kg', examples: 'A dress, a few tops, accessories, jewellery' },
  { v: 'MEDIUM', label: 'Medium', hint: 'Up to ~5 kg',                 examples: 'A coat, shoes, a bag, a few items together' },
  { v: 'LARGE',  label: 'Large',  hint: 'Up to ~15 kg',            examples: 'Boots, heavy knitwear, bundles, small electronics' },
];
